import { useId } from 'react';
import './TableSort.css';
import { FiArrowDown, FiArrowUp, FiChevronDown } from 'react-icons/fi';

export interface TableSortValue { field: string; direction: 'asc' | 'desc' }
export interface TableSortOption { value: string; label: string }

export function TableSort({ value, options, onChange, loading = false }: {
  value: TableSortValue; options: TableSortOption[]; onChange: (value: TableSortValue) => void; loading?: boolean;
}) {
  const controlId = useId();
  return <div className="table-sort" role="group" aria-label="Table sorting">
    <label className="table-sort-field" htmlFor={controlId}><span className="table-sort-label">Sort by</span>
    <span className="table-sort-select-wrap">
    <select id={controlId} className="table-sort-select" value={value.field}
      onChange={event => onChange({ ...value, field: event.target.value })}>
      {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
    </select>
    <FiChevronDown className="table-sort-chevron" aria-hidden />
    </span></label>
    <button type="button" className="table-sort-direction"
      aria-busy={loading}
      title={value.direction === 'asc' ? 'Ascending — click to reverse' : 'Descending — click to reverse'}
      aria-label={`Sort ${value.direction === 'asc' ? 'descending' : 'ascending'}`}
      onClick={() => onChange({ ...value, direction: value.direction === 'asc' ? 'desc' : 'asc' })}>
      {value.direction === 'asc' ? <FiArrowUp aria-hidden /> : <FiArrowDown aria-hidden />}
      <span className="table-sort-direction-short" aria-hidden>{value.direction === 'asc' ? 'Asc' : 'Desc'}</span>
      <span className="table-sort-direction-label">{value.direction === 'asc' ? 'Ascending' : 'Descending'}</span>
    </button>
    <span className="table-sort-feedback" role="status" aria-live="polite">{loading ? 'Updating results…' : ''}</span>
  </div>;
}

export function SortHeading({ field, label, value, onChange }: {
  field: string; label: string; value: TableSortValue; onChange: (value: TableSortValue) => void;
}) {
  return <button type="button" aria-label={`Sort by ${label}`} onClick={() => onChange({ field,
    direction: value.field === field && value.direction === 'desc' ? 'asc' : 'desc' })}
    className="table-sort-heading">
    {label}{value.field === field && (value.direction === 'asc' ? <FiArrowUp aria-hidden /> : <FiArrowDown aria-hidden />)}
  </button>;
}
